import React from "react";
import { Clock, Activity } from "lucide-react";
import { formatDiagnosticDate } from "../../../utils/dateFormatter";

// Helper function to determine status styling
function getStatusStyle(status) {
  if (status === "True") {
    return "bg-green-500 hover:bg-green-600 border-green-500";
  } else if (status === "False") {
    return "bg-red-500 hover:bg-red-600 border-red-500";
  }
  // Default style for unknown status
  return "bg-gray-500 hover:bg-gray-600 border-gray-500";
}

function UploaderStatus({ diagnosticData }) {
  // Extract uploader status data safely
  const uploaderData = diagnosticData?.UploaderApplicationStatus?.[0] || {};
  
  // Extract values with defaults
  const uploaderStatus = uploaderData.UploaderStatus || "--";
  const systemTimestamp = formatDiagnosticDate(uploaderData.SystemTimestamp);
  const lastUpdatedTimestamp = formatDiagnosticDate(uploaderData.DateofModification);
  
  return (
    <div className="space-y-4">
      {/* Uploader Status Card */}
      <div className="bg-white p-4 rounded-lg shadow-md border-l-4 border-blue-500 flex flex-col items-center justify-center text-center">
        <div className="flex items-center justify-center gap-2">
          <Activity className="text-blue-500" size={20} />
          <h3 className="text-lg font-bold text-gray-800">Uploader Status</h3>
        </div>
        <div className="mt-2 w-full md:w-[85%] mx-auto px-3 py-2 border border-gray-300 rounded-lg text-center text-white text-sm font-medium">
          <div className={`${getStatusStyle(uploaderStatus)} px-3 py-2 rounded-lg`}>
            {uploaderStatus === "True" ? "Running" : uploaderStatus === "False" ? "Stopped" : uploaderStatus}
          </div>
        </div>
      </div>

      {/* System Time Stamp Card */}
      <div className="bg-white p-4 rounded-lg shadow-md border-l-4 border-green-500 flex flex-col items-center justify-center text-center">
        <div className="flex items-center justify-center gap-2">
          <Clock className="text-green-500" size={20} />
          <h3 className="text-lg font-bold text-gray-800">System Time Stamp</h3>
        </div>
        <div className="mt-2 w-full md:w-[85%] mx-auto px-3 py-2 border border-gray-300 rounded-lg text-center text-gray-700 bg-gray-50 text-sm font-medium">
          {systemTimestamp}
        </div>
      </div>

      {/* Last Updated Timestamp Card */}
      <div className="bg-white p-4 rounded-lg shadow-md border-l-4 border-purple-500 flex flex-col items-center justify-center text-center">
        <div className="flex items-center justify-center gap-2">
          <Clock className="text-purple-500" size={20} />
          <h3 className="text-lg font-bold text-gray-800">Last Updated Timestamp</h3>
        </div>
        <div className="mt-2 w-full md:w-[85%] mx-auto px-3 py-2 border border-gray-300 rounded-lg text-center text-gray-700 bg-gray-50 text-sm font-medium">
          {lastUpdatedTimestamp}
        </div>
      </div>
    </div>
  );
}


export default UploaderStatus;